export const HMDA_EDIT_MODAL = 'HMDA_EDIT_MODAL';
export const HMDA_EXPORT_MODAL = 'HMDA_EXPORT_MODAL';
export const HMDA_MANAGE_DELETED_MODAL = 'HMDA_MANAGE_DELETED_MODAL';

export const setHmdaEditModal = (state) => (dispatch) => {
    dispatch({ type: HMDA_EDIT_MODAL, state });
};

export const setHmdaExportModal = (state) => (dispatch) => {
    dispatch({ type: HMDA_EXPORT_MODAL, state });
};

export const setHmdaManageDeletedModal = (state) => (dispatch) => {
    dispatch({ type: HMDA_MANAGE_DELETED_MODAL, state });
};

export default {
    HMDA_EDIT_MODAL,
    HMDA_EXPORT_MODAL,
    HMDA_MANAGE_DELETED_MODAL,
    setHmdaEditModal,
    setHmdaExportModal,
    setHmdaManageDeletedModal,
};
